<template>
  <div class="footer">
    <div class="footer-content flex-row">
      <div class="flex-column left">
        <div class="entrance">
          <ul class="footer-headline flex-row">
            <li v-for="item in this.entranceList" @click="to(item.path)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="footer-info flex-column">
          <div>
            公司地址：中国(山东)自由贸易试验区济南片区舜华路街道新泺大街1768号齐鲁软件园大厦B座A区A511室
          </div>
          <div>联系电话：4009013689转1</div>
          <div>联系邮箱：business@zilueit.com</div>
        </div>
      </div>
      <div class="right flex-row">
        <div class="flex-column QRCode">
          <div><img src="@/assets/footer/lectureHall.jpg" /></div>
          <div>
            关注数智合规冯军讲堂<br />
            获取深度合规解读
          </div>
        </div>
        <div class="flex-column QRCode">
          <div><img src="@/assets/footer/officialAccounts.png" /></div>
          <div>
            关注药销通公众号<br />
            获取更多合规资讯
          </div>
        </div>
        <div class="flex-column QRCode">
          <div><img src="@/assets/footer/douyin.png" /></div>
          <div>
            抖音扫码关注<br />
            学习更多合规知识
          </div>
        </div>
        <div class="flex-column QRCode">
          <div><img src="@/assets/footer/service.png" /></div>
          <div>添加官方客服</div>
        </div>
      </div>
    </div>
    <div
      class="flex-row flex-center"
      style="color: #a7a7a8; padding-bottom: 10px"
    >
      <span>Copyright © 2018-{{ year }} 版权所有 山东资略信息技术有限公司</span>
      <a
        target="_blank"
        style="margin: 10px"
        href="https://xyt.xcc.cn/getpcInfo?sn=1527170301719142400&amp;certType=8&amp;url=*.yaoxiaotong.cn&amp;language=CN"
      >
        <img
          src="https://program.xinchacha.com/xyt/xcc_small_ssl.png"
          style="width: 15px"
        />
      </a>

      <a
        style="color: #a7a7a8"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noopener noreferrer"
        >鲁 ICP备 16002366 号</a
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      year: moment().format("YYYY"),
      entranceList: [
        { name: "关于药销通", path: "/contactUs" },
        { name: "产品与服务", path: "/tradingSquare" },
        { name: "产品套餐", path: "/productPackage" },
        { name: "药销通合规学苑", path: "/complianceStudy" },
      ],
    };
  },
  methods: {
    to(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="scss">
li {
  cursor: pointer;
  font-size: 16px;
}

.footer {
  // height: $global-footer-height;
  background-color: $global-footer-bg;
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: center;
  color: $global-footer-font-color;
}

.footer-content {
  margin: 0 auto;
  width: $global-content-width;
  height: $global-footer-height;
  justify-content: space-between;
}

.left {
  margin-top: 99px;
  // margin-left: 360px;
}

.right {
  margin-top: 99px;
  // margin-right: 360px;
  width: 544px;
  justify-content: space-between;
}

.entrance {
  .footer-headline > li:hover {
    color: $global-default-primary;
  }

  .footer-headline {
    justify-content: space-between;
    font-size: $global-footer-headline-font-size;
    color: $global-footer-font-color;
    line-height: 22px;
    margin-bottom: 10px;
  }
}

.footer-info {
  width: 460px;
  margin-top: 50px;
  height: 80px;
  font-size: $global-footer-font-size;
  color: $global-footer-font-color;
  justify-content: space-between;
  text-align: left;
}

.QRCode {
  align-items: center;

  > :first-child {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;

    img {
      width: 100%;
    }
  }

  > :last-child {
    width: 126px;
    font-size: $global-footer-subtitle-font-size;
    color: $global-footer-subtitle-font-color;
  }
}
</style>
